import {
    getAuthToken
} from './token.js';
import config from '../../config';

const API_URL = config.apiUrl;

const fetchOpts = (method, body = null) => {
    let option = Object.assign({}, {
        method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }, body ? {
        body: JSON.stringify(body)
    } : {});

    if (getAuthToken()) {
        option = Object.assign({}, {
            method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getAuthToken()}`
            }
        }, body ? {
            body: JSON.stringify(body)
        } : {});
    }

    return option;
};

const API = {
    get: (url) => fetch(`${API_URL}${url}`, fetchOpts('GET')),
    post: (url, data) => fetch(`${API_URL}${url}`, fetchOpts('POST', data)),
    put: (url, data)  => fetch(`${API_URL}${url}`, fetchOpts('PUT', data)),
    delete: (url) => fetch(`${API_URL}${url}`, fetchOpts('DELETE'))
};

export default API;


/** WEBPACK FOOTER **
 ** ./src/utils/api.js
 **/